import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { resources, videos } from '../data';

function VideoCard({ video, t }) {
  return (
    <article className="content-card video-card">
      <div className="video-cover">
        <span><SafeIcon icon={FiIcons.FiPlay} /></span>
        <small>{video.duration}</small>
      </div>
      <div className="card-body">
        <span className="category">{t[video.category]}</span>
        <h3>{t[video.title]}</h3>
        <div className="progress-label">
          <span>{video.progress}% {t.progress}</span>
          <strong>{t.resume}</strong>
        </div>
        <div className="progress-track">
          <span style={{ width: `${video.progress}%` }} />
        </div>
      </div>
    </article>
  );
}

function ResourceCard({ resource, t }) {
  return (
    <article className="content-card resource-card">
      <span className="resource-icon"><SafeIcon icon={FiIcons.FiFileText} /></span>
      <div>
        <span className="category">{t[resource.type]}</span>
        <h3>{t[resource.title]}</h3>
        <small>{t[resource.date]}</small>
      </div>
      <SafeIcon icon={FiIcons.FiArrowUpRight} className="resource-arrow" />
    </article>
  );
}

function SectionHeading({ title, t }) {
  return (
    <div className="section-heading">
      <h2>{title}</h2>
      <button type="button">{t.viewAll} <SafeIcon icon={FiIcons.FiArrowRight} /></button>
    </div>
  );
}

function HomePage({ user, t, onNavigate }) {
  const welcomeCopy = t[`welcome${user.role.charAt(0).toUpperCase()}${user.role.slice(1)}`];

  return (
    <motion.div className="page-content" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <section className="welcome-card">
        <div>
          <span className="eyebrow">{t[user.role]}</span>
          <h1>{t.welcome}, {user.name.split(' ')[0]}</h1>
          <p>{welcomeCopy}</p>
        </div>
        <div className="welcome-symbol"><SafeIcon icon={FiIcons.FiTrendingUp} /></div>
      </section>

      {user.role === 'recruiter' && (
        <button className="invitation-card" type="button" onClick={() => onNavigate('invitations')}>
          <span className="invitation-icon"><SafeIcon icon={FiIcons.FiMail} /></span>
          <span>
            <small>{t.pendingInvitations}</small>
            <strong>12</strong>
            <em>{t.invitationsNeedAttention}</em>
          </span>
          <b>{t.reviewInvitations} <SafeIcon icon={FiIcons.FiArrowRight} /></b>
        </button>
      )}

      <section className="content-section">
        <SectionHeading title={t.continueWatching} t={t} />
        <div className="horizontal-grid">
          {videos.map((video) => <VideoCard video={video} t={t} key={video.id} />)}
        </div>
      </section>

      <section className="content-section">
        <SectionHeading title={t.newThisWeek} t={t} />
        <div className="resource-grid">
          {resources.map((resource) => <ResourceCard resource={resource} t={t} key={resource.id} />)}
        </div>
      </section>
    </motion.div>
  );
}

export default HomePage;